import { NOTIFICATION_PUBLIC_KEY } from 'config/settings';
import http from '../http'
const useNotification = () => {

    const sendNotification = (body, icon, type) => {

        const getType = (type) => {
            const types = {
                bell: 'מערכת MyBee 🔔',
                siren: 'מערכת MyBee 🚨',
                varning: 'מערכת MyBee ⚠️',
                voltage: 'מערכת MyBee ⚡'
            };

            return types[type] || types.bell;
        };

        const title = getType(type)

        if (Notification?.permission === 'granted') {
            new Notification(title, {
                body: body ?? "",
                icon: icon ?? ""
            });
        }
        else {
            console.info('התראות לא מורשות');
        }
    };

    const requestNotification = async (empId) => {
        if (!empId) return

        if (!('Notification' in window) || !('serviceWorker' in navigator)) {
            console.error('Notifications לא נתמכות בדפדפן זה');
            return -1
        }

        const existingSubscription = await checkExistingSubscription();
        if (existingSubscription) return 1

        const permission = await Notification?.requestPermission();
        if (permission === "granted") {
            await subscribeToPushNotifications(empId);
            console.info("🎉 Push Notifications הופעלו בהצלחה!");
            return 1
        }
        else if (permission === "denied") {
            console.warn("❌ המשתמש חסם את ההתראות.");
            return -2;
        }
        return 0;
    };

    const subscribeToPushNotifications = async (empId) => {
        if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
            console.info("🔴 Push Notifications לא נתמכות בדפדפן זה.");
            return;
        }

        const registration = await navigator.serviceWorker.ready;

        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: NOTIFICATION_PUBLIC_KEY,
        });

        console.info("✅ נרשמת בהצלחה ל-Push Notifications:");

        const data = {
            subscription: JSON.stringify(subscription),
            empId: empId
        }

        await http.post("notificationSubscription/register", data);
    };

    const checkIsDefaultPermission = () => {
        if (typeof window === 'undefined' || !('Notification' in window))
            return

        let value = false
        if (Notification?.permission === 'default')
            value = true

        return value
    }

    const checkIsDeniedPermission = () => {
        let value = false
        if (Notification?.permission === 'denied')
            value = true

        return value
    }

    const checkIsGrantedPermission = () => {
        let value = false
        if (Notification?.permission === 'granted')
            value = true

        return value
    }

    const checkExistingSubscription = async () => {
        const registration = await navigator.serviceWorker.getRegistration();

        if (registration) {
            const subscription = await registration.pushManager.getSubscription();

            if (subscription) {
                console.info('המנוי כבר קיים');
                return subscription;
            } else {
                console.info('אין מנוי קיים');
                return null;
            }
        } else {
            console.info('אין Service Worker פעיל');
            return null;
        }
    };

    return {
        sendNotification,
        requestNotification,
        checkIsDeniedPermission,
        checkIsDefaultPermission,
        checkIsGrantedPermission
    }
}

export default useNotification